<template>
  <DModal :show-close="false" :isBgOverlay="true" :placeInTop="true" @close="$emit('close')">
    <div class="d-modal" slot="insertComponent">
      <div class="d-modal__header">
        <h2>Rediger fraværsanmodning</h2>
        <div class="d-modal__close icon__bg-circle" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="d-modal__content">
        <UserAbsence
          :selectedSubject="selectedSubject"
          :resetCounter="resetAbsenceCounter"
          @setSubject="setSelectedSubject">
        </UserAbsence>
        <div class="d-group">
          <label class="d-label">Dato</label>
          <DatepickerRange
            :allowSameDate="true"
            :startdate="initStartDate"
            :enddate="initEndDate"
            @startchanged="setStartDate"
            @endchanged="setEndDate">
          </DatepickerRange>
        </div>
        <div class="time-changer__group">
          <label class="d-label">Tid</label>
          <TimeChanger
            :showIcon="true"
            :start="startTime"
            :end="endTime"
            :isFiveMinutesInterval="false"
            @updateStart="setStartTime"
            @updateEnd="setEndTime">
          </TimeChanger>
        </div>
        <div class="d-group marg-1-top">
          <label class="d-label">Evt. note</label>
          <textarea class="do-input" v-model="note"></textarea>
        </div>
      </div>
      <div class="d-modal__buttons d-modal__buttons__flex"
           v-if="selectedTab === 'request'"
           style="padding: 1rem;">
        <button class="do-bttn do-bttn--danger"
                :class="{'do-bttn--loading': isDeleting}"
                content='Slet anmodning'
                v-tippy="{
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window'
              }"
                @click="deleteRequest">
          <span class="icon-bin"></span>
        </button>
        <div class="do-submit-buttons">
          <button class="do-bttn" @click="$emit('close')">{{ $t('vue2.common.cancel') }}</button>
          <button class="do-bttn do-bttn--submit do-bttn--submit--disabled"
                  v-if="!isValidated">
            {{ $t('vue2.common.create') }}
          </button>
          <button class="do-bttn do-bttn--submit" :class="{'do-bttn--submit--loading': isSubmitting}" v-else
                  @click="submit">{{ $t('vue2.common.update') }}
          </button>
        </div>
      </div>
    </div>
  </DModal>
</template>

<script>
import docendo from '../../docendo'
import DModal from '../common/DModal'
import eventbus from '../../eventbus'
import {mapGetters} from 'vuex'
import moment from 'moment'
import DatepickerRange from '../datepicker/DatePickerRange.vue'
import TimeChanger from '../TimeChanger.vue'
import UserAbsence from './UserAbsence.vue'
import Tabs from '../common/Tabs'
import UserRequestList from './UserRequestList.vue'

export default {
  components: {UserRequestList, UserAbsence, DatepickerRange, TimeChanger, DModal, Tabs},
  props: {
    isShowTabs: {
      type: Boolean,
      default: true
    },
    editRequest: {
      default: null
    }
  },
  data () {
    return {
      initStartDate: moment(),
      initEndDate: moment(),
      startDate: moment(),
      endDate: moment(),
      startTime: moment().set({'hour': 8, 'minutes': 0}),
      endTime: moment().set({'hour': 16, 'minutes': 0}),
      selectedSubject: null,
      note: '',
      isSubmitting: false,
      activeSchoolId: null,
      isMultipleSchoolsActive: false,
      selectedTab: 'request',
      resetAbsenceCounter: 0,
      isDeleting: false
    }
  },
  computed: {
    ...mapGetters([
      'userCalendars',
      'schoolId'
    ]),
    user () {
      return this.$store.state.user
    },
    userSchools () {
      return this.user && this.user.schools ? this.user.schools : []
    },
    userSchoolsSorted () {
      return this.userSchools.sort((a, b) => a.name.localeCompare(b.name))
    },
    isValidated () {
      return this.selectedSubject
    },
    dbEventStart () {
      const date = moment(this.startDate).format('YYYY-MM-DD')
      const time = this.startTime.locale('LT')
      return moment(date).set({
        hour: time.get('hour'),
        minutes: time.get('minutes')
      })
    },
    dbEventEnd () {
      const date = moment(this.endDate).format('YYYY-MM-DD')
      const time = this.endTime.locale('LT')
      return moment(date).set({
        hour: time.get('hour'),
        minutes: time.get('minutes')
      })
    }
  },
  watch: {
    editRequest: {
      immediate: true,
      handler (val) {
        if (val) {
          this.startDate = moment(val.start_time)
          this.endDate = moment(val.end_time)
          this.initStartDate = moment(val.start_time)
          this.initEndDate = moment(val.end_time)
          this.startTime = moment(val.start_time)
          this.endTime = moment(val.end_time)
          this.note = val.request_note || ''
          this.selectedSubject = {
            id: val.subject_id
          }
        } else {
          this.resetForm()
        }
      }
    }
  },
  methods: {
    deleteRequest () {
      this.isDeleting = true
      const schoolId = this.editRequest.school_id
      const id = this.editRequest.id
      docendo.deleteRequest(schoolId, id, success => {
        this.showToast('Anmodning slettet', true)
        this.$emit('submitted')
        this.$emit('close')
      }, failure => {

      })
    },
    resetForm () {
      this.startDate = moment()
      this.endDate = moment()
      this.startTime = moment().set({hour: 8, minutes: 0})
      this.endTime = moment().set({hour: 16, minutes: 0})
      this.selectedSubject = null
      this.note = ''
      this.resetAbsenceCounter++
    },
    setSelectedSubject (subject) {
      this.selectedSubject = subject
    },
    setStartDate (payload) {
      this.startDate = payload
    },
    setEndDate (payload) {
      this.endDate = payload
    },
    setStartTime (payload) {
      this.startTime = payload
    },
    setEndTime (payload) {
      this.endTime = payload
    },
    showToast (message, success) {
      eventbus.toast = {text: message, success}
    },
    submit () {
      this.isSubmitting = true
      const schoolId = this.selectedSubject.school_id
      const startTime = this.dbEventStart
      const endTime = this.dbEventEnd
      const requestNote = this.note
      const subjectId = this.selectedSubject.id
      const id = this.editRequest.id
      docendo.updateRequest(schoolId, id, subjectId, startTime, endTime, requestNote, success => {
        this.showToast('Anmodning opdateret', true)
        this.$emit('submitted')
        this.$emit('close')
      }, failure => {
        this.showToast(failure, false)
        this.isSubmitting = false
      })
    }
  }
}
</script>

<style scoped>
.d-modal {
  width: 850px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
}

.d-modal__close {
  font-size: 16px !important;
}

.d-modal__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.d-modal__content {
  padding: 1rem;
  overflow-y: auto;
  max-height: calc(100vh - 2rem - 52px - 60px);
}

.d-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.do-spinner__container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
}

textarea.do-input {
  min-height: 120px
}

.d-modal__buttons__flex {
  display: flex;
  justify-content: space-between;
}

.do-submit-buttons {
  display: flex;
  gap: 1rem;
}
</style>



// WEBPACK FOOTER //
// UserRequestForm.vue?4a9bfafb